import { createContext, useContext } from "react";

import { ExamContext } from "../components/exam/context/examContext";

import { Highlighter } from "./highlighter";

export const HighlighterContext = createContext<{
  enabled: boolean;
} | null>(null);

export const useExistingHighlights = () => {
  const [examState, dispatch] = useContext(ExamContext);

  return {
    onHighlighterInit: (placementId: string, highlighter: Highlighter) => {
      if (examState.highlights) {
        highlighter.deserializeHighlights(
          examState.highlights[placementId] ?? [],
        );
      }
      highlighter.addEventListener("highlight", () => {
        dispatch({
          type: "SET_ITEM_HIGHLIGHTS",
          data: {
            placementId: placementId,
            highlights: highlighter.serializeHighlights() ?? [],
          },
        });
      });
    },
  };
};
